import { render, staticRenderFns } from "./ImportStock.vue?vue&type=template&id=2c0779fc&"
import script from "./ImportStock.vue?vue&type=script&lang=js&"
export * from "./ImportStock.vue?vue&type=script&lang=js&"
import style0 from "./ImportStock.vue?vue&type=style&index=0&id=2c0779fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports